import { useChatSettingsPersistence } from '../../model/useChatSettingsPersistence';

/**
 * Invisible mount that activates templates-agent settings persistence + restore for the active chat
 * session (see {@link useChatSettingsPersistence}). Rendered once inside the chat session tree, where
 * the chat store and query-client providers exist. Renders nothing; a no-op for non-templates agents.
 */
export function ChatSettingsPersistenceMount(): null {
  useChatSettingsPersistence();
  return null;
}
